import { Button } from "PFComponents/button";
import { Inline, Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { Vacancy as VacancyType } from "PFTypes";
import { useTranslation } from "react-i18next";

import { ClosedVacancy, ClosedVacancyProps } from "./closed_vacancy";
import { OpenVacancy, OpenVacancyProps } from "./open_vacancy";

type VacancyProps = {
  vacancy: VacancyType;
  vacancyNumber: number;
  onReopenVacancy: VoidFunction;
};

export const Vacancy = ({
  candidateValue,
  closureReasons,
  selectedProfileIds,
  onCandidateChange,
  onReasonChange,
  onReopenVacancy,
  reasonValue,
  vacancy,
  vacancyNumber,
  profiles,
  filledRole
}: VacancyProps & OpenVacancyProps & Omit<ClosedVacancyProps, "closureDetails">) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.vacancies" });
  const isOpen = vacancy.state === "opened";

  return (
    <Tile variant="light" paddingVariant="lg">
      <Stack>
        <Inline spread>
          <Typography variant="h5">{t("vacancyNumber", { number: vacancyNumber })}</Typography>
          {!isOpen && <Button text={t("reopen")} onClick={onReopenVacancy} />}
        </Inline>
        {isOpen ? (
          <OpenVacancy
            closureReasons={closureReasons}
            reasonValue={reasonValue}
            candidateValue={candidateValue}
            selectedProfileIds={selectedProfileIds}
            onReasonChange={onReasonChange}
            onCandidateChange={onCandidateChange}
          />
        ) : (
          <ClosedVacancy
            closureDetails={vacancy.closureDetails}
            profiles={profiles}
            filledRole={filledRole}
            closureReasons={closureReasons}
          />
        )}
      </Stack>
    </Tile>
  );
};
